import withViewport from '@aveneo/frontmoon-viewport-watcher/lib/hocs/withViewport';
import Carousel from './Carousel';

import CarouselItem from './CarouselItem';

export { CarouselItem };

export default withViewport(Carousel);
